import React from "react";
import UpdateLinks from "./ULinks";
import { useParams } from "react-router-dom";

export function DUpdateLinks(props) {
    const param = useParams();
    return <UpdateLinks param={param} {...props} />
}
